
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/what-is-the-population-project",
      function () {
        return require("private-next-pages/what-is-the-population-project.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/what-is-the-population-project"])
      });
    }
  